import { api, apiMain } from './config/axios';
import { store } from '../store';

export const getServices = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/services', {}, config);
};

export const updateServiceImages = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/update-services-images', payload, config);
};

export const getServicesAvailability = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/system/service-availability', {}, config);
};

export const getCategoriesAvailability = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/system/category-availability', {}, config);
};

export const getAppSetting = async () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/app-setting', {}, config);
};

export const updateAppSetting = async (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.put('/api/v1/admin/app-setting', payload, config);
};

export const changeServicesAvailability = (serviceId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/system/service-availability/${serviceId}`, payload, config);
};

export const changeCategoryAvailability = (categoryId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/system/category-availability/${categoryId}`, payload, config);
};

export const reorderCategoryAvailability = (items) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/system/category-availability/reorder', { items }, config);
};

export const getCurrentProcessor = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/processor', {}, config);
};

export const updateCurrentServiceProcessor = (processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const payload = { processor: { name: processor } };

  return api.post('/api/v1/admin/processor', payload, config);
};

export const getCurrentDiscount = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/discount', {}, config);
};

export const updateCurrentServiceDiscount = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.post('/api/v1/admin/discount', payload, config);
};

export const updateServices = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/services/update', payload, config);
};

export const regenerateResellingServices = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/reselling/services/regenerate', payload, config);
};

export const createResellingApiService = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/reselling/services', payload, config);
};

export const getProcessors = (query = {}) => api.get('/api/v1/admin/current-processors', query);

export const getProcessorProduct = async (processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.get('/api/v1/admin/current-processor-product', { processor }, config);
};

export const createNewProduct = async (payload, processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.post(`/api/v1/admin/services?processor=${processor}`, payload, config);
};

export const deleteProduct = async (productId) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.delete(`/api/v1/admin/services/${productId}`, {}, config);
};

export const uploadDashboardImage = async (data) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };

  return api.post('/api/v1/admin/upload-advert-asset', data, config);
};

export const getServiceProviders = async () => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.get('/api/v1/admin/service-providers', {}, config);
};

export const updateServiceProvider = async (providerId, payload) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.put(`/api/v1/admin/service-providers/${providerId}`, payload, config);
};

export const adjustServiceProviderBalance = async (providerId, payload) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.post(`/api/v1/admin/service-providers/${providerId}/balance`, payload, config);
};

export const updateProduct = async (productId, payload) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.put(`/api/v1/admin/services/${productId}`, payload, config);
};

export const syncServiceProviderBalances = async () => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.post('/api/v1/admin/service-providers/sync-balance', {}, config);
};

export const deleteServiceProvider = async (providerId) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.delete(`/api/v1/admin/service-providers/${providerId}`, {}, config);
};

export const createServiceProvider = async (payload) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.post('/api/v1/admin/service-providers', payload, config);
};

export const validateServiceProviderCredentials = async (payload) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.post('/api/v1/admin/service-providers/validate-credentials', payload, config);
};

export const getAvailableProcessors = () => apiMain.get('/api/v1/user/processors');

export const getServiceProviderBanks = async (providerId) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.get(`/api/v1/admin/service-providers/${providerId}/banks`, {}, config);
};

export const syncServiceProviderBanks = async (providerId) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.post(`/api/v1/admin/service-providers/${providerId}/sync-banks`, {}, config);
};

export const getServiceProviderAccount = async (providerId) => {
  const { token } = store.getState().auth;
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return api.get(`/api/v1/admin/service-providers/${providerId}/account`, {}, config);
};

export const getProcessorCatalogPlans = (processorSlug, params = {}) =>
  apiMain.get(`/api/v1/user/processors/${processorSlug}/plans`, params);

/**
 * Maps frontend service names ("Data", "Airtime", "Cable", "Electricity", "ResultCheck", "Internet")
 * to backend ProcessorPlan categories ("data", "airtime", "cable", "electricity", "result_check", "internet").
 */
export const mapServiceCategoryToCatalogCategory = (serviceName = '') => {
  const norm = String(serviceName || '').toLowerCase().trim();
  if (norm === 'data') return 'data';
  if (norm === 'airtime') return 'airtime';
  if (norm === 'cable') return 'cable';
  if (norm === 'electricity') return 'electricity';
  if (norm === 'resultcheck' || norm === 'result_check' || norm === 'exam') return 'result_check';
  if (norm === 'internet') return 'internet';
  return norm || 'data';
};

/**
 * Extracts numeric volume in MB and sizeLabel from plan name strings (e.g. "1.5GB" -> { volumeMb: 1536, sizeLabel: "1.5GB" }).
 */
export const parseVolumeMb = (nameStr = '') => {
  if (!nameStr) return { volumeMb: null, sizeLabel: null };

  const match = String(nameStr).match(/(\d+(?:\.\d+)?|\d+\.)\s*(TB|GB|MB)/i);
  if (!match) return { volumeMb: null, sizeLabel: null };

  const rawNum = match[1].replace(/\.$/, '');
  const num = parseFloat(rawNum);
  const unit = match[2].toUpperCase();

  if (Number.isNaN(num)) return { volumeMb: null, sizeLabel: null };

  let volumeMb = 0;
  if (unit === 'TB') {
    volumeMb = Math.round(num * 1024 * 1024);
  } else if (unit === 'GB') {
    volumeMb = Math.round(num * 1024);
  } else {
    volumeMb = Math.round(num);
  }

  const sizeLabel = `${num}${unit}`;
  return { volumeMb, sizeLabel };
};

// In-memory cache for provider catalog plans during session
const providerCatalogCache = new Map();

/**
 * Fetches and caches catalog plans for a specific processor/provider and service category.
 */
export const fetchCatalogPlansForProvider = async (providerSlug, category = 'data') => {
  const cleanSlug = String(providerSlug || '').toLowerCase().trim();
  if (!cleanSlug) return [];
  const cat = mapServiceCategoryToCatalogCategory(category);
  const cacheKey = `${cleanSlug}_${cat}`;
  const collapsedSlug = cleanSlug.replace(/[^a-z0-9]/g, '');
  const collapsedKey = `${collapsedSlug}_${cat}`;

  if (providerCatalogCache.has(cacheKey) && providerCatalogCache.get(cacheKey)?.length > 0) {
    return providerCatalogCache.get(cacheKey);
  }
  if (collapsedSlug && providerCatalogCache.has(collapsedKey) && providerCatalogCache.get(collapsedKey)?.length > 0) {
    return providerCatalogCache.get(collapsedKey);
  }

  try {
    const res = await getProcessorCatalogPlans(cleanSlug, {
      category: cat,
      limit: 1000,
    });
    const responseData = res.data?.data;
    let plans = [];
    if (responseData && Array.isArray(responseData.plans)) {
      const { plans: pList } = responseData;
      plans = pList;
    } else if (Array.isArray(responseData)) {
      plans = responseData;
    }

    // If 0 plans and slug has hyphens, fallback to collapsed alphanumeric slug
    if ((!plans || plans.length === 0) && collapsedSlug && collapsedSlug !== cleanSlug) {
      try {
        const fbRes = await getProcessorCatalogPlans(collapsedSlug, {
          category: cat,
          limit: 1000,
        });
        const fbData = fbRes.data?.data;
        if (fbData && Array.isArray(fbData.plans) && fbData.plans.length > 0) {
          plans = fbData.plans;
        } else if (Array.isArray(fbData) && fbData.length > 0) {
          plans = fbData;
        }
      } catch (fbErr) {
        // ignore fallback error
      }
    }

    if (plans && plans.length > 0) {
      providerCatalogCache.set(cacheKey, plans);
      if (collapsedSlug) {
        providerCatalogCache.set(collapsedKey, plans);
      }
    }
    return plans || [];
  } catch (err) {
    // If request failed and slug has hyphens, try collapsed slug
    if (collapsedSlug && collapsedSlug !== cleanSlug) {
      try {
        const fbRes = await getProcessorCatalogPlans(collapsedSlug, {
          category: cat,
          limit: 1000,
        });
        const fbData = fbRes.data?.data;
        let plans = [];
        if (fbData && Array.isArray(fbData.plans)) {
          plans = fbData.plans;
        } else if (Array.isArray(fbData)) {
          plans = fbData;
        }
        if (plans.length > 0) {
          providerCatalogCache.set(cacheKey, plans);
          providerCatalogCache.set(collapsedKey, plans);
          return plans;
        }
      } catch (fbErr2) {
        // ignore
      }
    }
    return [];
  }
};

/**
 * Clears the provider catalog memory cache.
 */
export const clearProviderCatalogCache = () => {
  providerCatalogCache.clear();
};

/**
 * Resolves the legacy processor slug from any legacy service representation.
 */
export const extractProcessorSlugFromLegacy = (service = {}) => {
  if (!service) return 'kybdata';

  if (service.processor?.processorSlug) {
    return String(service.processor.processorSlug).toLowerCase().trim();
  }

  if (service.processor?.name) {
    return String(service.processor.name).toLowerCase().trim();
  }

  if (service.processor?.identifier) {
    return String(service.processor.identifier).toLowerCase().trim();
  }

  if (service.provider) {
    return String(service.provider).toLowerCase().trim();
  }

  if (service.details?.provider) {
    return String(service.details.provider).toLowerCase().trim();
  }

  if (typeof service.processor?.authorization === 'string') {
    const rawAuth = service.processor.authorization.split('_TOKEN')[0].split('_')[0];
    if (rawAuth) return rawAuth.toLowerCase().trim();
  }

  return 'kybdata';
};

/**
 * Extracts legacy plan ID from any service representation.
 */
export const extractPlanIdFromLegacy = (service = {}) => {
  if (!service) return '';

  const raw =
    service.planId ??
    service.details?.planId ??
    service.details?.plan_id ??
    service.processor?.payload?.plan ??
    service.processor?.payload?.cableplan ??
    service.processor?.payload?.exam_name ??
    service.customData?.planId ??
    service.customData?.plan_id ??
    service.details?.planCode ??
    '';

  return String(raw).trim();
};

/**
 * Extracts or infers network ID from legacy service attributes.
 */
export const extractNetworkIdFromLegacy = (service = {}) => {
  if (!service) return undefined;

  const explicitNetId =
    service.networkId ??
    service.details?.networkId ??
    service.details?.network_id ??
    service.customData?.networkid ??
    service.customData?.network_id;

  if (explicitNetId !== undefined && explicitNetId !== null && explicitNetId !== '') {
    return Number.isNaN(Number(explicitNetId)) ? explicitNetId : Number(explicitNetId);
  }

  const combined = `${service.network || ''} ${service.category || ''} ${service.name || ''} ${service.details?.name || ''}`.toUpperCase();
  if (combined.includes('MTN')) return 1;
  if (combined.includes('GLO')) return 2;
  if (combined.includes('9MOBILE') || combined.includes('ETISALAT') || combined.includes('T2')) return 3;
  if (combined.includes('AIRTEL')) return 4;
  if (combined.includes('SMILE')) return 5;

  return undefined;
};

/**
 * Extracts cost price / buying amount from legacy service.
 */
export const extractCostPriceFromLegacy = (service = {}) => {
  if (!service) return undefined;
  if (service.buyingAmount !== undefined && service.buyingAmount !== null && service.buyingAmount !== '') {
    const num = Number(service.buyingAmount);
    return Number.isNaN(num) ? undefined : num;
  }
  return undefined;
};

/**
 * Detects telecom network name from legacy attributes if missing.
 */
export const detectNetworkName = (service = {}) => {
  if (service.network) return service.network;
  const combined = `${service.category || ''} ${service.name || ''} ${service.details?.name || ''}`.toUpperCase();
  if (combined.includes('MTN')) return 'MTN';
  if (combined.includes('AIRTEL')) return 'AIRTEL';
  if (combined.includes('GLO')) return 'GLO';
  if (combined.includes('9MOBILE') || combined.includes('ETISALAT') || combined.includes('T2')) return '9MOBILE';
  if (combined.includes('SMILE')) return 'SMILE';
  return null;
};

/**
 * Detects data plan type classification from legacy attributes if missing.
 */
export const detectPlanTypeName = (service = {}) => {
  if (service.planType) return service.planType;
  const combined = `${service.category || ''} ${service.name || ''} ${service.details?.name || ''}`.toUpperCase();
  if (combined.includes('SME 2') || combined.includes('SME2')) return 'SME 2';
  if (combined.includes('SME')) return 'SME';
  if (combined.includes('GIFTING')) return 'Gifting';
  if (combined.includes('COOPERATE') || combined.includes('CORPORATE') || combined.includes('CG')) return 'Corporate';
  if (combined.includes('SHARE') || combined.includes('SHRE')) return 'Share';
  if (combined.includes('TALK MORE') || combined.includes('TALKMORE')) return 'Talk More';
  return null;
};

/**
 * Searches a provider's catalog plans to see if a product exists.
 * Uniqueness check:
 * 1. Combination of `networkId` + `planId` (primary unique key for telecom data/airtime).
 * 2. `planId` alone (for cable/electricity/exam or within category).
 * 3. Smart match for data plans: matches networkId + data volume in MB + plan type.
 * 4. Name similarity match for cable/electricity/exam.
 */
export const findMatchingCatalogPlan = (service = {}, catalogPlans = [], options = {}) => {
  if (!Array.isArray(catalogPlans) || catalogPlans.length === 0) {
    return { matchedPlan: null, matchType: null, isVerified: false };
  }

  let targetPlanId = '';
  if (options.planId !== undefined) {
    targetPlanId = String(options.planId).trim();
  } else {
    targetPlanId = String(service.planId || extractPlanIdFromLegacy(service) || '').trim();
  }

  let targetNetworkId = extractNetworkIdFromLegacy(service);
  if (options.networkId !== undefined) {
    const parsedNet = Number(options.networkId);
    targetNetworkId = Number.isNaN(parsedNet) ? options.networkId : parsedNet;
  }

  const targetName = String(options.name || service.details?.name || service.name || '').trim();
  const targetCategory = String(service.category || '').trim();
  const isData = String(service.service || '').toLowerCase() === 'data';

  // 1. Compound Match: planId AND networkId
  if (targetPlanId) {
    const compoundMatch = catalogPlans.find((cp) => {
      const idMatch =
        String(cp.planId).toLowerCase() === targetPlanId.toLowerCase() ||
        (cp.meta?.productId && String(cp.meta.productId).toLowerCase() === targetPlanId.toLowerCase());
      if (!idMatch) return false;
      if (targetNetworkId !== undefined && cp.networkId !== undefined) {
        return Number(cp.networkId) === Number(targetNetworkId);
      }
      return true;
    });

    if (compoundMatch) {
      return { matchedPlan: compoundMatch, matchType: 'exact_compound', isVerified: true };
    }

    // 2. Exact PlanId match
    const planIdMatch = catalogPlans.find(
      (cp) =>
        String(cp.planId).toLowerCase() === targetPlanId.toLowerCase() ||
        (cp.meta?.productId && String(cp.meta.productId).toLowerCase() === targetPlanId.toLowerCase())
    );

    if (planIdMatch) {
      return { matchedPlan: planIdMatch, matchType: 'exact_plan_id', isVerified: true };
    }
  }

  // 3. Smart Match for Data Plans: networkId + volumeMb + planType
  if (isData && targetNetworkId !== undefined) {
    const { volumeMb: targetVol } = parseVolumeMb(`${targetName} ${targetCategory}`);
    const targetType = detectPlanTypeName(service);

    if (targetVol) {
      const networkPlans = catalogPlans.filter(
        (cp) => cp.networkId !== undefined && Number(cp.networkId) === Number(targetNetworkId)
      );

      // Filter by volume match
      const volumeMatches = networkPlans.filter((cp) => {
        const { volumeMb: cpVol } = parseVolumeMb(`${cp.planName} ${cp.dataType || ''}`);
        return cpVol === targetVol;
      });

      if (volumeMatches.length === 1) {
        return { matchedPlan: volumeMatches[0], matchType: 'smart_volume_exact', isVerified: true };
      }

      if (volumeMatches.length > 1 && targetType) {
        const typeMatch = volumeMatches.find((cp) => {
          const cpType = (cp.dataType || cp.planName || '').toUpperCase();
          return cpType.includes(targetType.toUpperCase());
        });
        if (typeMatch) {
          return { matchedPlan: typeMatch, matchType: 'smart_volume_type', isVerified: true };
        }
      }
    }
  }

  // 4. Fuzzy Name Match for Non-Data (Cable, Electricity, Exam)
  if (!isData && targetName) {
    const cleanTarget = targetName.toLowerCase().replace(/[^a-z0-9]/g, '');
    const nameMatch = catalogPlans.find((cp) => {
      const cleanCpName = String(cp.planName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      return cleanCpName && (cleanCpName.includes(cleanTarget) || cleanTarget.includes(cleanCpName));
    });

    if (nameMatch) {
      return { matchedPlan: nameMatch, matchType: 'name_similarity', isVerified: true };
    }
  }

  return { matchedPlan: null, matchType: null, isVerified: false };
};

/**
 * Checks based on preferred and candidate providers whether a legacy service exists in vendor catalogs.
 */
export const verifyAndMatchServiceWithProvider = async (
  service = {},
  preferredProviderSlug = null,
  candidateProviders = []
) => {
  const legacySlug = extractProcessorSlugFromLegacy(service);
  const providerCandidates = [];

  if (preferredProviderSlug) {
    providerCandidates.push(String(preferredProviderSlug).toLowerCase().trim());
  }
  if (legacySlug && !providerCandidates.includes(legacySlug)) {
    providerCandidates.push(legacySlug);
  }

  // Also include tenant's active configured providers if provided
  if (Array.isArray(candidateProviders)) {
    candidateProviders.forEach((p) => {
      const slug = (typeof p === 'string' ? p : p.slug || p.identifier || p.name || '').toLowerCase().trim();
      if (slug && !providerCandidates.includes(slug)) {
        providerCandidates.push(slug);
      }
    });
  }

  if (providerCandidates.length === 0) {
    providerCandidates.push('kybdata');
  }

  const category = service.service || 'Data';

  // Concurrently prefetch candidate catalogs
  const catalogs = await Promise.all(
    providerCandidates.map((slug) => fetchCatalogPlansForProvider(slug, category))
  );

  for (let i = 0; i < providerCandidates.length; i += 1) {
    const slug = providerCandidates[i];
    const catalog = catalogs[i];
    if (catalog && catalog.length > 0) {
      const matchResult = findMatchingCatalogPlan(service, catalog);
      if (matchResult.isVerified && matchResult.matchedPlan) {
        return {
          ...matchResult,
          providerSlug: slug,
        };
      }
    }
  }

  return {
    matchedPlan: null,
    matchType: null,
    isVerified: false,
    providerSlug: providerCandidates[0] || 'kybdata',
  };
};

/**
 * Builds canonical processorRoutes array from a legacy service.
 * If matched catalog plan exists, uses verified vendor attributes with isCustomId: false.
 */
export const buildV2RoutesFromLegacy = (service = {}, overrides = {}) => {
  if (Array.isArray(service.processorRoutes) && service.processorRoutes.length > 0) {
    return service.processorRoutes.map((route, idx) => ({
      priority: route.priority || idx + 1,
      processorSlug: (route.processorSlug || route.name || 'kybdata').toLowerCase().trim(),
      planId: String(route.planId ?? ''),
      networkId: route.networkId !== undefined ? route.networkId : extractNetworkIdFromLegacy(service),
      costPrice: route.costPrice !== undefined ? Number(route.costPrice) : extractCostPriceFromLegacy(service),
      retryOnFailure: route.retryOnFailure !== false,
      maxRetries: typeof route.maxRetries === 'number' ? route.maxRetries : 0,
      onFailureAction: route.onFailureAction || 'next_processor',
      enabled: route.enabled !== false,
      isCustomId: Boolean(route.isCustomId),
      ...(route.customRoutes ? { customRoutes: route.customRoutes } : {}),
      ...(route.customConfig ? { customConfig: route.customConfig } : {}),
    }));
  }

  const matchedPlan = overrides.matchedPlan || overrides.verifiedPlan || null;

  let slug = extractProcessorSlugFromLegacy(service);
  if (matchedPlan?.processorSlug) {
    slug = matchedPlan.processorSlug;
  }
  if (overrides.processorSlug) {
    slug = overrides.processorSlug;
  }

  let planId = extractPlanIdFromLegacy(service);
  if (matchedPlan?.planId !== undefined) {
    planId = String(matchedPlan.planId);
  }
  if (overrides.planId !== undefined) {
    planId = String(overrides.planId);
  }

  let networkId = extractNetworkIdFromLegacy(service);
  if (matchedPlan?.networkId !== undefined) {
    networkId = matchedPlan.networkId;
  }
  if (overrides.networkId !== undefined) {
    networkId = overrides.networkId;
  }

  let costPrice = extractCostPriceFromLegacy(service);
  if (matchedPlan?.costPrice !== undefined) {
    costPrice = Number(matchedPlan.costPrice);
  }
  if (overrides.costPrice !== undefined) {
    costPrice = overrides.costPrice;
  }

  let isCustomId = !matchedPlan;
  if (overrides.isCustomId !== undefined) {
    isCustomId = Boolean(overrides.isCustomId);
  }

  const initialRoute = {
    priority: 1,
    processorSlug: slug,
    planId,
    ...(networkId !== undefined ? { networkId } : {}),
    ...(costPrice !== undefined ? { costPrice } : {}),
    retryOnFailure: overrides.retryOnFailure !== undefined ? overrides.retryOnFailure : true,
    maxRetries: typeof overrides.maxRetries === 'number' ? overrides.maxRetries : 0,
    onFailureAction: overrides.onFailureAction || 'next_processor',
    enabled: overrides.enabled !== false,
    isCustomId,
  };

  return [initialRoute];
};

/**
 * Builds the complete V2 update payload from a legacy service.
 */
export const buildV2PayloadFromLegacy = (service = {}, overrides = {}) => {
  const routes = buildV2RoutesFromLegacy(service, overrides);
  const primaryRoute = routes[0] || {};
  const network = detectNetworkName(service);
  const planType = detectPlanTypeName(service);

  const payload = {
    useV2Engine: true,
    processorRoutes: routes,
    planId: primaryRoute.planId || service.planId || '',
    ...(primaryRoute.networkId !== undefined ? { networkId: primaryRoute.networkId } : {}),
    ...(network ? { network } : {}),
    ...(planType ? { planType } : {}),
    ...overrides,
  };

  // If matched provider costPrice is available and buyingAmount on service is 0 or missing, sync it
  if (primaryRoute.costPrice !== undefined && (!service.buyingAmount || Number(service.buyingAmount) === 0)) {
    payload.buyingAmount = primaryRoute.costPrice;
  }

  // Clean helper properties from payload
  delete payload.matchedPlan;
  delete payload.verifiedPlan;
  delete payload.candidateProviders;

  return payload;
};

/**
 * The ONE canonical function for updating any legacy service to V2.
 * Automatically checks and searches provider catalogs before conversion.
 */
export const updateLegacyServiceToV2 = async (serviceOrId, maybeService = null, overrides = {}) => {
  let productId;
  let serviceData;
  let customOverrides = overrides;

  if (typeof serviceOrId === 'object' && serviceOrId !== null) {
    productId = serviceOrId.id;
    serviceData = serviceOrId;
    if (typeof maybeService === 'object' && maybeService !== null) {
      customOverrides = maybeService;
    }
  } else {
    productId = serviceOrId;
    if (typeof maybeService === 'object' && maybeService !== null) {
      serviceData = maybeService;
    } else {
      const storeServices = store?.getState?.()?.services?.services || [];
      serviceData = storeServices.find((s) => String(s.id) === String(productId)) || {};
    }
  }

  if (!productId) {
    throw new Error('updateLegacyServiceToV2 requires a valid service object or service ID');
  }

  // If matchedPlan was not provided, check provider catalog automatically
  let matchedPlan = customOverrides.matchedPlan || null;
  let isVerified = Boolean(matchedPlan);
  let matchType = customOverrides.matchType || (matchedPlan ? 'explicit' : null);
  let resolvedProviderSlug = customOverrides.processorSlug || null;

  if (!matchedPlan) {
    const verifyResult = await verifyAndMatchServiceWithProvider(
      serviceData,
      customOverrides.processorSlug,
      customOverrides.candidateProviders || []
    );
    if (verifyResult.isVerified && verifyResult.matchedPlan) {
      matchedPlan = verifyResult.matchedPlan;
      isVerified = true;
      matchType = verifyResult.matchType;
      resolvedProviderSlug = verifyResult.providerSlug;
    }
  }

  const v2Payload = buildV2PayloadFromLegacy(serviceData, {
    ...customOverrides,
    ...(matchedPlan ? { matchedPlan, processorSlug: resolvedProviderSlug } : {}),
  });

  const res = await updateProduct(productId, v2Payload);
  return {
    ...res,
    matchedPlan,
    isVerified,
    matchType,
    providerSlug: resolvedProviderSlug || extractProcessorSlugFromLegacy(serviceData),
    planId: v2Payload.planId,
  };
};

// Aliases for 100% backward compatibility
export const convertProductToV2 = updateLegacyServiceToV2;

/**
 * Batch converts an array of legacy services to V2 with provider catalog verification.
 */
export const convertServicesBatchToV2 = async (serviceList = [], overrides = {}) => {
  if (!Array.isArray(serviceList) || serviceList.length === 0) {
    return { successCount: 0, total: 0, failedCount: 0, verifiedCount: 0, customCount: 0, details: [] };
  }

  // Pre-fetch catalogs for candidate providers in parallel
  const category = serviceList[0]?.service || 'Data';
  const providerSlugsToFetch = new Set();

  serviceList.forEach((s) => {
    const slug = overrides.processorSlug || extractProcessorSlugFromLegacy(s);
    if (slug) providerSlugsToFetch.add(slug.toLowerCase().trim());
  });

  if (Array.isArray(overrides.candidateProviders)) {
    overrides.candidateProviders.forEach((p) => {
      const slug = (typeof p === 'string' ? p : p.slug || p.identifier || p.name || '').toLowerCase().trim();
      if (slug) providerSlugsToFetch.add(slug);
    });
  }

  await Promise.allSettled(
    Array.from(providerSlugsToFetch).map((slug) => fetchCatalogPlansForProvider(slug, category))
  );

  const results = await Promise.allSettled(
    serviceList.map((s) => updateLegacyServiceToV2(s, null, overrides))
  );

  let verifiedCount = 0;
  let customCount = 0;
  let successCount = 0;
  const details = [];

  results.forEach((r, idx) => {
    const item = serviceList[idx];
    if (r.status === 'fulfilled' && r.value?.ok) {
      successCount += 1;
      if (r.value.isVerified) {
        verifiedCount += 1;
      } else {
        customCount += 1;
      }
      details.push({
        id: item.id,
        name: item.details?.name || item.name,
        ok: true,
        isVerified: r.value.isVerified,
        matchedPlan: r.value.matchedPlan,
        planId: r.value.planId,
      });
    } else {
      details.push({
        id: item.id,
        name: item.details?.name || item.name,
        ok: false,
        error: r.status === 'rejected' ? r.reason?.message : r.value?.data?.message,
      });
    }
  });

  const failedCount = serviceList.length - successCount;

  return { successCount, total: serviceList.length, failedCount, verifiedCount, customCount, details };
};

export const updateLegacyServicesBatchToV2 = convertServicesBatchToV2;




